import React, {useEffect} from 'react'
import {Container, Grid, Typography, Box, Card} from '@material-ui/core'
import WizardPreview from '../BarcodeWizardPreview'
import BarcodeNavHeaderButtons from '../BarcodeNavHeaderButtons'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeLibraryPreview.styles'

export default function BarcodeLibraryPreview(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const [barcodeSettingRecord] = React.useState(props.location.state.barcodeData)
  const [previewFieldValue] = React.useState(props.location.state.previewFieldValue)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
      <BarcodeNavHeaderButtons previous={props.location.state.previous} />

      <Grid container>
        <Grid item xs={6}>
          <Container>
            <Card>
              <Grid container>
                <Grid container item xs={8} justify="flex-start">
                  <Typography variant="h5">
                    <div className={classes.titleStyle}>
                      {t('barcode.library.preview-template.template-details')}
                    </div>
                  </Typography>
                </Grid>
                <Grid container item xs={4} justify="flex-end" margin="auto">
                  <Box marginTop={3} marginRight={3}>
                    <Link to="barcode-library">
                      {t('barcode.library.preview-template.choose-template')}
                    </Link>
                  </Box>
                </Grid>
                <Grid container justify="flex-start">
                  <div className={classes.descriptionStyle}>
                    {t('barcode.library.preview-template.sheet-template')}
                  </div>
                </Grid>
                <Grid container justify="flex-start">
                  <div className={classes.informationStyle}>{barcodeSettingRecord.sheet.name}</div>
                </Grid>

                <Grid container justify="flex-start">
                  <div className={classes.descriptionStyle}>
                    {t('barcode.library.preview-template.label-template')}
                  </div>
                </Grid>
                <Grid container justify="flex-start">
                  <div className={classes.informationStyle}>{barcodeSettingRecord.label.name}</div>
                </Grid>

                <Grid container item xs={12} justify="flex-start">
                  <Typography variant="h5">
                    <div className={classes.titleStyle}>
                      {t('barcode.library.preview-template.barcode-automatic')}
                    </div>
                  </Typography>
                </Grid>

                <Grid container>
                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.preview-template.name')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>{barcodeSettingRecord.name}</div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.preview-template.type')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.barcodeType}
                    </div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.preview-template.label-template')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.label.name}
                    </div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {previewFieldValue
                          ? t('barcode.library.preview-template.group')
                          : t('barcode.library.preview-template.digits')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {previewFieldValue
                        ? barcodeSettingRecord.entityName
                        : barcodeSettingRecord.digits}
                    </div>
                  </Grid>

                  <Grid container item xs={6} hidden={previewFieldValue}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.preview-template.start-number')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.startNumber}
                    </div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {previewFieldValue
                          ? t('barcode.library.preview-template.field')
                          : t('barcode.library.preview-template.prefix')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {previewFieldValue
                        ? barcodeSettingRecord.fieldName
                        : barcodeSettingRecord.prefix}
                    </div>
                  </Grid>

                  <Grid container item xs={6} hidden={previewFieldValue}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.preview-template.last-code')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.lastPrinted}
                    </div>
                  </Grid>

                  <Grid container item xs={6} hidden={previewFieldValue}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.preview-template.next-code')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.nextToPrint}
                    </div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.preview-template.output')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.output.toUpperCase()}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Container>
          <Box marginBottom={5} />
        </Grid>

        <Grid item xs={6}>
          <WizardPreview />
        </Grid>
      </Grid>
    </div>
  )
}
